package it.neckar.lizergy.model.stumps

import it.neckar.lizergy.model.project.ProjectConfiguration
import it.neckar.uuid.NativeUuid
import kotlinx.serialization.Serializable

@Serializable
data class SwitchMeterBox(
  override val uuid: NativeUuid,
  override val projectId: ProjectConfiguration.PhotovoltaicsProjectId,
) : ProjectStump
